import {
  AdminModerationQueueResponse,
  AdminPlaceReviewFilters,
  AdminPlaceReviewsResponse,
  AdminResolveModerationPayload,
  AdminResolveModerationResponse,
} from "@/types/admin-place-reviews"

import { baseApi } from "./base-api"

function toSearchParams(filters: AdminPlaceReviewFilters): URLSearchParams {
  const searchParams = new URLSearchParams()
  if (filters.page) searchParams.set("page", String(filters.page))
  if (filters.per_page) searchParams.set("per_page", String(filters.per_page))
  if (filters.status?.length) {
    searchParams.set("status", filters.status.join(","))
  }
  if (filters.search) searchParams.set("search", filters.search)
  if (filters.needs_human_review !== undefined) {
    searchParams.set("needs_human_review", String(filters.needs_human_review))
  }
  if (filters.has_user_reports !== undefined) {
    searchParams.set("has_user_reports", String(filters.has_user_reports))
  }
  if (filters.hidden_is_terminal !== undefined) {
    searchParams.set("hidden_is_terminal", String(filters.hidden_is_terminal))
  }
  if (filters.updated_after) {
    searchParams.set("updated_after", filters.updated_after)
  }
  if (filters.updated_before) {
    searchParams.set("updated_before", filters.updated_before)
  }
  if (filters.order_by) searchParams.set("order_by", filters.order_by)
  if (filters.order_direction) {
    searchParams.set("order_direction", filters.order_direction)
  }
  return searchParams
}

export const adminPlaceReviewsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminPlaceReviews: builder.query<
      AdminPlaceReviewsResponse,
      AdminPlaceReviewFilters
    >({
      query: (filters) => ({
        url: `/api/store-admin/place_reviews?${toSearchParams(filters).toString()}`,
      }),
      providesTags: ["AdminPlaceReviews"],
    }),
    getPlaceReviewModerationQueue: builder.query<
      AdminModerationQueueResponse,
      void
    >({
      query: () => ({
        url: "/api/store-admin/place_reviews/moderation_queue?limit=50",
      }),
      providesTags: ["AdminPlaceReviews"],
    }),
    resolvePlaceReviewModeration: builder.mutation<
      AdminResolveModerationResponse,
      { id: number; payload: AdminResolveModerationPayload }
    >({
      query: ({ id, payload }) => ({
        url: `/api/store-admin/place_reviews/${id}/resolve`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["AdminPlaceReviews"],
    }),
  }),
})

export const {
  useGetAdminPlaceReviewsQuery,
  useGetPlaceReviewModerationQueueQuery,
  useResolvePlaceReviewModerationMutation,
} = adminPlaceReviewsApi
